/**
 * set-clinic-license API が返す stripeWarnings の表示用ユーティリティ
 */

export function formatStripeWarningMessage(warnings) {
  if (!Array.isArray(warnings) || warnings.length === 0) return '';

  return warnings.map((w) => {
    switch (w.type) {
      case 'subscription-not-found':
        return `無効な Stripe サブスク ID（${w.clearedSubscriptionId}）をクリアしました。`;
      case 'subscription-cleared':
        return 'Stripe 連携 ID をクリアしました。';
      case 'subscription-repaired':
        return `Stripe サブスクを新規作成して連携しました（${w.subscriptionId}）。`;
      case 'subscription-reused':
        return `既存の Stripe サブスクを再利用しました（${w.subscriptionId}）。二重課金は発生していません。`;
      case 'subscription-repair-skipped':
        return `Stripe 再連携をスキップしました（${w.reason}）。`;
      default:
        return w.type || 'Stripe 警告';
    }
  }).join('\n');
}

export function collectStripeWarnings(results) {
  const warnings = [];
  (results || []).forEach((result) => {
    if (Array.isArray(result?.stripeWarnings)) {
      warnings.push(...result.stripeWarnings);
    }
  });
  return warnings;
}

export function buildSaveMessageWithStripeWarnings(baseMessage, warnings) {
  const warningText = formatStripeWarningMessage(warnings);
  if (!warningText) return baseMessage;
  return `${baseMessage}\n\n【Stripe】\n${warningText}`;
}
